"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _commonReact = require("@devsta/common-react");

var _ModalFunctions = require("../utils/ModalFunctions");

var _PostsList = _interopRequireDefault(require("./PostsList"));

var _ModalSwitcher = _interopRequireDefault(require("./ModalSwitcher"));

var _ManagePostsHeader = _interopRequireDefault(require("./ManagePostsHeader"));

var _ViewPostModal = _interopRequireDefault(require("../../../common/components/ViewPostModal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CHUNK_SIZE = 16;

var ManagePosts = /*#__PURE__*/function (_Component) {
  _inherits(ManagePosts, _Component);

  function ManagePosts(props) {
    var _this;

    _classCallCheck(this, ManagePosts);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ManagePosts).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "openModal", (0, _lodash.default)(function (openedModalName) {
      return function (modalPayload) {
        _this.setState({
          openedModalName: openedModalName,
          modalPayload: modalPayload
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "openReportModal", (0, _lodash.default)(function (modalPayload) {
      return function () {
        _this.setState({
          openedModalName: 'reportPost',
          modalPayload: modalPayload
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "fetchInspirations", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var variables,
            _this$props,
            getInspirations,
            fetchAssets,
            _ref2,
            data,
            error,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                variables = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _this$props = _this.props, getInspirations = _this$props.getInspirations, fetchAssets = _this$props.fetchAssets;
                _context.next = 4;
                return getInspirations(_objectSpread({
                  sortBy: 'updatedAt',
                  limit: null
                }, variables));

              case 4:
                _ref2 = _context.sent;
                data = _ref2.data;
                error = _ref2.error;

                if (!(!data || error || !data.getInspirations)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", void _this.setState({
                  error: true
                }));

              case 9:
                fetchAssets(data && data.getInspirations);

                _this.setState({
                  posts: data.getInspirations,
                  displayedPosts: data.getInspirations.slice(0, CHUNK_SIZE)
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "loadMore", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$state, _this$state$posts, posts, _this$state$displayed, displayedPosts;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state = _this.state, _this$state$posts = _this$state.posts, posts = _this$state$posts === void 0 ? [] : _this$state$posts, _this$state$displayed = _this$state.displayedPosts, displayedPosts = _this$state$displayed === void 0 ? [] : _this$state$displayed;

              if (posts.length > displayedPosts.length) {
                _this.setState({
                  displayedPosts: posts.slice(0, displayedPosts.length + CHUNK_SIZE)
                });
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "updatePostsInState", function (postsIdsToEdit, postPayload) {
      _this.setState(function (_ref4) {
        var posts = _ref4.posts;

        if (!posts) {
          return {};
        }

        var newPosts = (0, _ModalFunctions.updatePostsByIds)(posts, postsIdsToEdit, postPayload);
        return {
          posts: newPosts,
          displayedPosts: newPosts.slice(0, CHUNK_SIZE)
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updatePostInState", function (post) {
      _this.updatePostsInState([post.inspirationId], post);
    });

    _defineProperty(_assertThisInitialized(_this), "deletePostInState", function (inspirationId) {
      _this.setState(function (_ref5) {
        var posts = _ref5.posts;

        if (!posts) {
          return {};
        }

        var newPosts = posts.filter(function (post) {
          return inspirationId !== post.inspirationId;
        });
        return {
          posts: newPosts,
          displayedPosts: newPosts.slice(0, CHUNK_SIZE)
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setPostFeatured", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(inspirationId) {
        var setInspirationFeatured, _ref7, error, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                setInspirationFeatured = _this.props.setInspirationFeatured;
                _context3.next = 3;
                return setInspirationFeatured(inspirationId);

              case 3:
                _ref7 = _context3.sent;
                error = _ref7.error;
                data = _ref7.data;

                if (!error) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return");

              case 8:
                _this.setState(function (_ref8) {
                  var posts = _ref8.posts;

                  if (!posts) {
                    return {};
                  }

                  var newPosts = posts.map(function (post) {
                    return _objectSpread({}, post, {
                      featuredAt: inspirationId === post.inspirationId ? data.setInspirationFeatured : post.featuredAt
                    });
                  });
                  return {
                    posts: newPosts,
                    displayedPosts: newPosts.slice(0, CHUNK_SIZE)
                  };
                });

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        openedModalName: void 0,
        modalPayload: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeViewPostModal", function () {
      _this.setState({
        modalPostId: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setPostsListRef", function (ref) {
      if (!ref) {
        return;
      }

      _this._postsListRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "getPostsListRef", function () {
      return _this._postsListRef;
    });

    var hash = props.location.hash;

    var _inspirationId = hash ? hash.substring(1) : void 0;

    _this.state = {
      modalPostId: _inspirationId
    };
    return _this;
  }

  _createClass(ManagePosts, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchInspirations();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          history = _this$props2.history,
          updateInspiration = _this$props2.updateInspiration,
          deleteInspiration = _this$props2.deleteInspiration,
          organisationId = _this$props2.organisationId,
          orgPermissions = _this$props2.orgPermissions;
      var _this$state2 = this.state,
          posts = _this$state2.posts,
          displayedPosts = _this$state2.displayedPosts,
          modalPayload = _this$state2.modalPayload,
          openedModalName = _this$state2.openedModalName,
          error = _this$state2.error,
          modalPostId = _this$state2.modalPostId;

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      return _react.default.createElement("div", {
        className: "page",
        ref: this.setPostsListRef
      }, modalPostId && _react.default.createElement(_ViewPostModal.default, {
        onClose: this.closeViewPostModal,
        isVisible: Boolean(modalPostId),
        inspirationId: modalPostId,
        overrideStatus: true,
        openReportModal: this.openReportModal({
          postIdToEdit: modalPostId
        })
      }), _react.default.createElement(_ModalSwitcher.default, {
        modalPayload: modalPayload,
        openedModalName: openedModalName,
        onClose: this.closeModal,
        updateInspiration: updateInspiration,
        deleteInspiration: deleteInspiration,
        setPostFeatured: this.setPostFeatured,
        updatePostInState: this.updatePostInState,
        deletePostInState: this.deletePostInState,
        updatePostsInState: this.updatePostsInState,
        refetchPosts: this.fetchInspirations,
        organisationId: organisationId
      }), _react.default.createElement(_ManagePostsHeader.default, {
        history: history,
        showCreatePostsModal: this.openModal('createPosts'),
        orgPermissions: orgPermissions
      }), _react.default.createElement(_PostsList.default, {
        loading: !posts,
        history: history,
        posts: displayedPosts || [],
        totalResults: posts ? posts.length : 0,
        loadMore: this.loadMore,
        getPostsListRef: this.getPostsListRef,
        refetchPosts: this.fetchInspirations,
        showDeleteConfirmationModal: this.openModal('deletePost'),
        showFeaturedConfirmationModal: this.openModal('setFeatured'),
        showPublishConfirmationModal: this.openModal('publishPost'),
        showEditPostModal: this.openModal('editPost'),
        orgPermissions: orgPermissions
      }));
    }
  }]);

  return ManagePosts;
}(_react.Component);

exports.default = ManagePosts;